import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: string;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: undefined,
};

const getAvatarSlice = createSlice({
  name: "getAvatar",
  initialState,
  reducers: {
    getAvatarStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getAvatarSuccess: (state, action: PayloadAction<string>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getAvatarFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetAvatar: () => {
      return { ...initialState };
    },
  },
});

export const {
  getAvatarStart,
  getAvatarSuccess,
  getAvatarFailed,
  resetAvatar,
} = getAvatarSlice.actions;

export default getAvatarSlice.reducer;
